import { render, staticRenderFns } from "./MessageTemplateButtons.vue?vue&type=template&id=764fbb9c"
import script from "./MessageTemplateButtons.vue?vue&type=script&lang=js"
export * from "./MessageTemplateButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports